import { Heading } from '@customerio/pluma-components/react';
import { TextLabel } from '@customerio/pluma-components/react';
import { ModalCloseButton } from '@customerio/pluma-components/react';
import { Box } from '@customerio/pluma-components/react';
import { Icon } from '@customerio/pluma-components/react';
import type { RocketMeta } from '../../rocket-configs';
import { Image } from '@customerio/pluma-components/react';

import { CONFIGS } from '../../rocket-configs';
import * as styles from './index.css';

export interface AdventureHeaderProps {
  config: RocketMeta;
  completedSteps: number;
  onClose: () => void;
  onBack: () => void;
}

export function AdventureHeader({ config, completedSteps, onClose, onBack }: AdventureHeaderProps) {
  const adventureIndex = CONFIGS.findIndex((c: RocketMeta) => c.id === config.id) + 1;
  const totalSteps = config.steps?.length ?? 0;

  return (
    <Box as="header">
      <Box display="flex" alignItems="center" gap="100" px="150" py="150">
        <Box as="button" onClick={onBack} display="flex" alignItems="center" color="accent" cursor="pointer">
          <Icon name="chevron-left" size="sm" />
          Back
        </Box>
        <ModalCloseButton onClick={onClose} className={styles.contentCloseButton} />
      </Box>
      <Box display="flex" alignItems="center" gap="100" px="250" py="150" className={styles.rocketHeaderContent}>
        <Image key={config.id} src={config.icon} width={40} height={40} alt="" />
        <Box>
          <TextLabel mb="050">
            {completedSteps} / {totalSteps} steps: Adventure {adventureIndex}
          </TextLabel>
          <Heading level="3">{config.title}</Heading>
        </Box>
      </Box>
    </Box>
  );
}
